require("utility/step_progress_meter.scss");

class StepProgressMeter extends React.Component {
	constructor(props) {
		super();
		autobind(this);
	}
	barWidth() {
		return 15 / this.props.numSteps;
	}
	renderTrackingBar(isComplete, keyIndex) {
		var statusClassName = isComplete ? "full" : "empty";

		return (
			<div className={ "trackingBar " + statusClassName }
				style={ { width: (this.barWidth() + "rem") } }
				key={ "bar" + keyIndex } />
		);
	}
	renderStepCircle(iconPathStem, isComplete, keyIndex) {
		var iconPath = iconPathStem;
		if (isComplete) {
			iconPath = iconPath + "-complete";
		}
		iconPath = iconPath + ".png";

		return (
			<div className="stepCircle" key={ "circle" + keyIndex }>
				<img src={ dynamicRequire(iconPath) } className="stepIcon" />
			</div>
		);
	}
	renderCurrentStepDisplay() {
		// Step number of bars, and (Step - 1) number of circles
		// (Step is 1-indexed)
		var circleWidth = 5;
		var barWidth = this.barWidth();

		var leftAmount = this.props.currentStep * barWidth + 
			(this.props.currentStep - 1) * circleWidth;

		var style = { left: (leftAmount + "rem") };

		return (
			<div className="currentStepDisplay" key="current" style={ style }>
				{ this.props.currentStepDisplay }
			</div>
		);
	}
	renderFinishImage() {
		return (
			<div className="finishImgDisplay" key="finish">
				<img src={ dynamicRequire(this.props.finishImgPath) } className="finishImg" />
			</div>
		);
	}

	render() {
		var currentStep = this.props.currentStep || 1;

		var stepsDisplay = [];
		// include the currentStepDisplay in the array if specified
		if (this.props.currentStepDisplay) {
			stepsDisplay.push(this.renderCurrentStepDisplay());
		}

		var initialBarDisplay = this.renderTrackingBar(true, 0);

		for (var i = 1; i <= this.props.numSteps; i++) {
			var isComplete = (i < currentStep);

			stepsDisplay.push(this.renderStepCircle(this.props.iconPathStems[i - 1], isComplete, i));
			stepsDisplay.push(this.renderTrackingBar(isComplete, i));
		}

		if (this.props.finishImgPath) {
			var finishImgDisplay = this.renderFinishImage();
		}

		return (
			<div className="stepProgressMeter">
				<div className="meterContainer">
					{ initialBarDisplay }
					{ stepsDisplay }
					{ finishImgDisplay }
				</div>
			</div>
		);
	}
};

StepProgressMeter.propTypes = StrictPropTypes({
	// starting index 1, total number of circle icon steps
	numSteps: PropTypes.number.isRequired,

	// starting index 1, defaults to 1 (first step)
	currentStep: PropTypes.number,

	// array of icon path stems for each step, must have corresponding incomplete and complete icons
	// e.g. "quiz-icons/warmup" stem assumes two images
	// incomplete: "quiz-icons/warmup.png" complete: "quiz-icons/warmup-complete.png"
	iconPathStems: PropTypes.array.isRequired,

	// image for the end of the meter (optional)
	finishImgPath: PropTypes.string,

	// display to replace the icon on the current step (optional)
	currentStepDisplay: PropTypes.object,
});

module.exports = StepProgressMeter;



// WEBPACK FOOTER //
// ./modules/components/utility/StepProgressMeter.js